import React from "react";
import {
  FaCompass,
  FaHotel,
  FaBinoculars,
  FaUmbrellaBeach,
  FaHeadset,
  FaComments,
  FaBriefcase,
  FaUsers,
  FaArrowRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "../css/styles.css";

const mainServices = [
  {
    icon: <FaCompass />,
    title: "Tailor-Made Safaris",
    description: "We design fully customized journeys across Kenya and Tanzania based on your interests, travel style, and schedule.",
  },
  {
    icon: <FaHotel />,
    title: "Accommodation Booking",
    description: "From luxury safari lodges to boutique tented camps and beach resorts, we carefully select exceptional stays for every itinerary.",
  },
  {
    icon: <FaBinoculars />,
    title: "Safari Experiences",
    description: "Game drives, walking safaris, hot air balloon safaris, cultural visits, and unique wildlife encounters.",
  },
  {
    icon: <FaUmbrellaBeach />,
    title: "Beach Extensions",
    description: "Combine your safari with relaxing beach stays in Zanzibar, Diani, or Watamu.",
  },
  {
    icon: <FaHeadset />,
    title: "Seamless Planning & Support",
    description: "From planning to the moment you return home, we coordinate every detail of your journey.",
  },
  {
    icon: <FaComments />,
    title: "Travel Consultation",
    description: "Professional advice to help you plan the perfect trip.",
  },
];

const corporateServices = [
  {
    icon: <FaBriefcase />,
    title: "Conferences & Events",
    description: "Planning for corporate meetings and events.",
  },
  {
    icon: <FaUsers />,
    title: "Team Building",
    description: "Outdoor team experiences designed for collaboration.",
  },
];

const Services = () => {
  return (
    <div className="svc-page">
      {/* ===== HERO ===== */}
      <section className="svc-hero">
        <img
          src="https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto,f_auto,w_1920/v1776344768/Our_Services_paetkq.jpg"
          alt="Safari Planning"
          className="svc-hero-bg"
        />
        <div className="svc-hero-overlay" />
        <div className="svc-hero-content">
          <span className="dest-hero-eyebrow">What We Do</span>
          <h1 className="svc-hero-title">Our Travel Planning Services</h1>
          <p className="svc-hero-sub">
            Expert-crafted safaris, handpicked lodges, and seamless end-to-end
            planning &#8212; so you can focus on the adventure.
          </p>
        </div>
      </section>

      {/* ===== MAIN SERVICES GRID ===== */}
      <section className="svc-grid-section">
        <div className="svc-grid-inner">
          <span className="section-tag centered">Safari & Leisure</span>
          <h2 className="section-heading svc-heading">How We Make Your Trip Unforgettable</h2>

          <div className="svc-grid">
            {mainServices.map((svc, i) => (
              <div className="svc-card" key={i}>
                <div className="svc-card-icon-wrap">
                  <span className="svc-card-icon">{svc.icon}</span>
                </div>
                <h3 className="svc-card-title">{svc.title}</h3>
                <p className="svc-card-desc">{svc.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CORPORATE ===== */}
      <section className="svc-corp-section">
        <div className="svc-corp-inner">
          <span className="section-tag centered svc-corp-tag">Corporate Travel</span>
          <h2 className="section-heading svc-corp-heading">For Business & Teams</h2>
          <p className="svc-corp-sub">
            We also organise corporate retreats, conferences, and team-building
            experiences across East Africa&#39;s most inspiring destinations.
          </p>

          <div className="svc-corp-grid">
            {corporateServices.map((svc, i) => (
              <div className="svc-corp-card" key={i}>
                <span className="svc-corp-card-icon">{svc.icon}</span>
                <div>
                  <h3>{svc.title}</h3>
                  <p>{svc.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="cta-section cta-clean">
        <div className="cta-content">
          <span className="cta-eyebrow">Ready to Begin?</span>
          <h2>Design Your Trip</h2>
          <p>
            Whether it&#39;s a romantic getaway, a family adventure, or a corporate
            retreat &#8212; we&#39;ll bring your vision to life.
          </p>
          <div className="hero-buttons" style={{ justifyContent: "center" }}>
            <Link to="/tours" className="cta-button">
              Start Planning <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;